/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Mitarbeiter API
 * Employee master data: contact details, organisation, keys, parking and vehicles.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Employee,
  ImportRequest,
  KeycloakOverview,
  LinkReport,
  LinkRequest,
  MarkLeftReport,
  MarkLeftRequest
} from '../models';

import { customFetch } from '../../fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getKeycloakOverviewUrl = () => {




  return `/api/admin/keycloak`
}

/**
 * @summary Every Keycloak user next to the matching employee (by stored Keycloak id, else by e-mail), plus the
employees that have no Keycloak account.
 */
export const keycloakOverview = async ( options?: Parameters<typeof customFetch>[1]): Promise<KeycloakOverview> => {

  return customFetch<KeycloakOverview>(getKeycloakOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getKeycloakOverviewQueryKey = () => {
    return [
    `/api/admin/keycloak`
    ] as const;
    }


export const getKeycloakOverviewQueryOptions = <TData = Awaited<ReturnType<typeof keycloakOverview>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keycloakOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKeycloakOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof keycloakOverview>>> = ({ signal }) => keycloakOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof keycloakOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KeycloakOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof keycloakOverview>>>
export type KeycloakOverviewQueryError = unknown


export function useKeycloakOverview<TData = Awaited<ReturnType<typeof keycloakOverview>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof keycloakOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof keycloakOverview>>,
          TError,
          Awaited<ReturnType<typeof keycloakOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKeycloakOverview<TData = Awaited<ReturnType<typeof keycloakOverview>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keycloakOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof keycloakOverview>>,
          TError,
          Awaited<ReturnType<typeof keycloakOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKeycloakOverview<TData = Awaited<ReturnType<typeof keycloakOverview>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keycloakOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every Keycloak user next to the matching employee (by stored Keycloak id, else by e-mail), plus the
employees that have no Keycloak account.
 */

export function useKeycloakOverview<TData = Awaited<ReturnType<typeof keycloakOverview>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keycloakOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKeycloakOverviewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getKeycloakImportUrl = () => {




  return `/api/admin/keycloak/import`
}

/**
 * @summary Creates an employee record from a Keycloak user (name, e-mail) and links the two.
 */
export const keycloakImport = async (importRequest: ImportRequest, options?: Parameters<typeof customFetch>[1]): Promise<Employee> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Employee>(getKeycloakImportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(importRequest)
  }
);}





export const getKeycloakImportMutationKey = () => ['keycloakImport'] as const;

export const getKeycloakImportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof keycloakImport>>, TError,KeycloakImportMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof keycloakImport>>, TError,KeycloakImportMutationVariables, TContext> => {

const mutationKey = getKeycloakImportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof keycloakImport>>, KeycloakImportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  keycloakImport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KeycloakImportMutationResult = NonNullable<Awaited<ReturnType<typeof keycloakImport>>>
    export type KeycloakImportMutationBody = ImportRequest
    export type KeycloakImportMutationError = unknown
    export type KeycloakImportMutationVariables = {data: ImportRequest}

    /**
 * @summary Creates an employee record from a Keycloak user (name, e-mail) and links the two.
 */
export const useKeycloakImport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof keycloakImport>>, TError,KeycloakImportMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof keycloakImport>>,
        TError,
        KeycloakImportMutationVariables,
        TContext
      > => {
      return useMutation(getKeycloakImportMutationOptions(options), queryClient);
    }
    export const getKeycloakLinkUrl = () => {




  return `/api/admin/keycloak/link`
}

export const keycloakLink = async (linkRequest: LinkRequest, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<void>(getKeycloakLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(linkRequest)
  }
);}





export const getKeycloakLinkMutationKey = () => ['keycloakLink'] as const;

export const getKeycloakLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof keycloakLink>>, TError,KeycloakLinkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof keycloakLink>>, TError,KeycloakLinkMutationVariables, TContext> => {

const mutationKey = getKeycloakLinkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof keycloakLink>>, KeycloakLinkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  keycloakLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KeycloakLinkMutationResult = NonNullable<Awaited<ReturnType<typeof keycloakLink>>>
    export type KeycloakLinkMutationBody = LinkRequest
    export type KeycloakLinkMutationError = unknown
    export type KeycloakLinkMutationVariables = {data: LinkRequest}

    export const useKeycloakLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof keycloakLink>>, TError,KeycloakLinkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof keycloakLink>>,
        TError,
        KeycloakLinkMutationVariables,
        TContext
      > => {
      return useMutation(getKeycloakLinkMutationOptions(options), queryClient);
    }
    export const getKeycloakLinkByEmailUrl = () => {




  return `/api/admin/keycloak/link-by-email`
}

/**
 * @summary Links every not yet linked employee to the Keycloak user with the same e-mail address.
 */
export const keycloakLinkByEmail = async ( options?: Parameters<typeof customFetch>[1]): Promise<LinkReport> => {

  return customFetch<LinkReport>(getKeycloakLinkByEmailUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getKeycloakLinkByEmailMutationKey = () => ['keycloakLinkByEmail'] as const;

export const getKeycloakLinkByEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof keycloakLinkByEmail>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof keycloakLinkByEmail>>, TError,void, TContext> => {

const mutationKey = getKeycloakLinkByEmailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof keycloakLinkByEmail>>, void> = () => {


          return  keycloakLinkByEmail(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KeycloakLinkByEmailMutationResult = NonNullable<Awaited<ReturnType<typeof keycloakLinkByEmail>>>

    export type KeycloakLinkByEmailMutationError = unknown


    /**
 * @summary Links every not yet linked employee to the Keycloak user with the same e-mail address.
 */
export const useKeycloakLinkByEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof keycloakLinkByEmail>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof keycloakLinkByEmail>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getKeycloakLinkByEmailMutationOptions(options), queryClient);
    }
    export const getKeycloakMarkLeftUrl = () => {




  return `/api/admin/keycloak/mark-left`
}

/**
 * @summary Sets active employees whose Keycloak account is disabled to "left". The account state is checked
again here, so a stale page cannot mark the wrong people.
 */
export const keycloakMarkLeft = async (markLeftRequest: MarkLeftRequest, options?: Parameters<typeof customFetch>[1]): Promise<MarkLeftReport> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<MarkLeftReport>(getKeycloakMarkLeftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(markLeftRequest)
  }
);}





export const getKeycloakMarkLeftMutationKey = () => ['keycloakMarkLeft'] as const;

export const getKeycloakMarkLeftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof keycloakMarkLeft>>, TError,KeycloakMarkLeftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof keycloakMarkLeft>>, TError,KeycloakMarkLeftMutationVariables, TContext> => {

const mutationKey = getKeycloakMarkLeftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof keycloakMarkLeft>>, KeycloakMarkLeftMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  keycloakMarkLeft(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KeycloakMarkLeftMutationResult = NonNullable<Awaited<ReturnType<typeof keycloakMarkLeft>>>
    export type KeycloakMarkLeftMutationBody = MarkLeftRequest
    export type KeycloakMarkLeftMutationError = unknown
    export type KeycloakMarkLeftMutationVariables = {data: MarkLeftRequest}

    /**
 * @summary Sets active employees whose Keycloak account is disabled to "left". The account state is checked
again here, so a stale page cannot mark the wrong people.
 */
export const useKeycloakMarkLeft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof keycloakMarkLeft>>, TError,KeycloakMarkLeftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof keycloakMarkLeft>>,
        TError,
        KeycloakMarkLeftMutationVariables,
        TContext
      > => {
      return useMutation(getKeycloakMarkLeftMutationOptions(options), queryClient);
    }
